import { render, staticRenderFns } from "./AgreementAction.vue?vue&type=template&id=870440ce"
import script from "./AgreementAction.vue?vue&type=script&lang=js"
export * from "./AgreementAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports